import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import type {
    ProductAttributeItem,
    ProductPomMeasurementResponse,
    ProductPomMeasurementSizeGroup,
} from './productPomMeasurement.types';

const mapSizeGroup = (size: any): ProductPomMeasurementSizeGroup => ({
    sizeCode: String(size?.sizeCode ?? size?.SizeCode ?? ''),
    barcode: Number(size?.barcode ?? size?.Barcode ?? 0),
    measurements: (size?.measurements ?? size?.Measurements ?? []).map((measurement: any) => ({
        epimPomId: Number(measurement?.epimPomId ?? measurement?.EpimPomId ?? 0),
        descriptionTr: String(measurement?.descriptionTr ?? measurement?.DescriptionTr ?? ''),
        pomSizeValue: measurement?.pomSizeValue ?? measurement?.PomSizeValue ?? null,
    })),
});

const mapAttribute = (attribute: any): ProductAttributeItem => ({
    key: String(attribute?.key ?? attribute?.Key ?? ''),
    value: String(attribute?.value ?? attribute?.Value ?? ''),
});

const mapResponse = (data: any): ProductPomMeasurementResponse | null => {
    if (!data) {
        return null;
    }

    const sizes = data.sizes ?? data.Sizes;
    if (!Array.isArray(sizes)) {
        return null;
    }

    return {
        requestedBarcode: Number(data.requestedBarcode ?? data.RequestedBarcode ?? 0),
        modelCode: String(data.modelCode ?? data.ModelCode ?? ''),
        colorCode: String(data.colorCode ?? data.ColorCode ?? ''),
        epimOptionId: data.epimOptionId ?? data.EpimOptionId ?? null,
        sizes: sizes.map(mapSizeGroup),
        productAttributes: (data.productAttributes ?? data.ProductAttributes ?? []).map(mapAttribute),
    };
};

const unwrapData = (payload: any): ProductPomMeasurementResponse | null => {
    if (!payload) {
        return null;
    }

    const candidates = [
        payload,
        payload.data,
        payload.Data,
        payload.data?.data,
        payload.data?.Data,
        payload.Data?.data,
        payload.Data?.Data,
    ];

    for (const candidate of candidates) {
        const mapped = mapResponse(candidate);
        if (mapped) {
            return mapped;
        }
    }

    return null;
};

const GetByBarcode = async (barcode: string): Promise<ProductPomMeasurementResponse | null> => {
    const trimmed = barcode?.trim();
    if (!trimmed) {
        return null;
    }

    const response = await request({
        url: ApiURL.Query.StudioQueryURLs.ProductPomMeasurementQueryURL.GetByBarcode(trimmed),
        method: RequestType.GET,
    });

    return unwrapData(response);
};

export const ProductPomMeasurementQuery = {
    GetByBarcode,
};

export default ProductPomMeasurementQuery;
